export interface PdfToolEntry {
  slug: string;
  title: string;
  tagline: string;
}

export const PDF_TOOLS: Record<string, PdfToolEntry> = {
  "fill-pdf-online": {
    slug: "fill-pdf-online",
    title: "Fill PDF online",
    tagline: "The broad filler. AI first, manual as a fallback.",
  },
  "ai-pdf-filler": {
    slug: "ai-pdf-filler",
    title: "AI PDF filler",
    tagline: "Paste once, AI maps to every field.",
  },
  "auto-fill-pdf": {
    slug: "auto-fill-pdf",
    title: "Auto fill PDF",
    tagline: "Reuse your saved details across any form.",
  },
  "edit-pdf-with-ai": {
    slug: "edit-pdf-with-ai",
    title: "Edit PDF with AI",
    tagline: "Describe the change, the AI places it.",
  },
  "edit-acroform-with-ai": {
    slug: "edit-acroform-with-ai",
    title: "Edit AcroForm with AI",
    tagline: "Fill named fields, keep the form machine-readable.",
  },
  "edit-pdf-free": {
    slug: "edit-pdf-free",
    title: "Free PDF editor",
    tagline: "Text, images, checkmarks, and form-field fill.",
  },
  "add-text-to-pdf": {
    slug: "add-text-to-pdf",
    title: "Add text to PDF",
    tagline: "Type a text box onto any page, even scans.",
  },
  "make-pdf-fillable": {
    slug: "make-pdf-fillable",
    title: "Make PDF fillable",
    tagline: "AI detects field positions on flat PDFs.",
  },
  "fill-pdf-from-photo": {
    slug: "fill-pdf-from-photo",
    title: "Fill PDF from a phone photo",
    tagline: "Snap a paper form, convert, fill in the browser.",
  },
  "fill-pdf-without-acrobat": {
    slug: "fill-pdf-without-acrobat",
    title: "Fill PDF without Acrobat",
    tagline: "No Adobe subscription, no install.",
  },
  "fill-rental-application": {
    slug: "fill-rental-application",
    title: "Fill a rental application",
    tagline: "Turn around a landlord's PDF the same day.",
  },
  "fill-w9-online": {
    slug: "fill-w9-online",
    title: "Fill W-9 online",
    tagline: "For freelancers and contractors. IRS source.",
  },
  "fill-w4-online": {
    slug: "fill-w4-online",
    title: "Fill W-4 online",
    tagline: "For new hires on day one. IRS source.",
  },
  "fill-1040-online": {
    slug: "fill-1040-online",
    title: "Fill Form 1040",
    tagline: "For DIY paper filers. IRS source.",
  },
  "fill-i9-online": {
    slug: "fill-i9-online",
    title: "Fill Form I-9",
    tagline: "Sections 1 and 2 in the browser. USCIS source.",
  },
};

/**
 * Grouping used by the site footer (and anywhere else the full catalog is
 * listed). Every tool page must appear in exactly one group — the footer is
 * the crawl path that keeps these pages from being sitemap-only orphans.
 */
export const TOOL_GROUPS: Record<string, string[]> = {
  "pdf tools": [
    "fill-pdf-online",
    "ai-pdf-filler",
    "auto-fill-pdf",
    "edit-pdf-with-ai",
    "edit-acroform-with-ai",
    "edit-pdf-free",
    "add-text-to-pdf",
    "make-pdf-fillable",
    "fill-pdf-from-photo",
    "fill-pdf-without-acrobat",
  ],
  "fill forms": [
    "fill-w9-online",
    "fill-w4-online",
    "fill-1040-online",
    "fill-i9-online",
    "fill-rental-application",
  ],
};

export const RELATED_TOOLS: Record<string, string[]> = {
  "fill-pdf-online": [
    "ai-pdf-filler",
    "auto-fill-pdf",
    "edit-pdf-free",
    "fill-pdf-without-acrobat",
  ],
  "ai-pdf-filler": [
    "auto-fill-pdf",
    "edit-pdf-with-ai",
    "edit-acroform-with-ai",
    "fill-pdf-online",
  ],
  "auto-fill-pdf": [
    "ai-pdf-filler",
    "fill-rental-application",
    "edit-pdf-with-ai",
    "fill-pdf-online",
  ],
  "edit-pdf-with-ai": [
    "ai-pdf-filler",
    "edit-acroform-with-ai",
    "edit-pdf-free",
    "auto-fill-pdf",
  ],
  "edit-acroform-with-ai": [
    "ai-pdf-filler",
    "edit-pdf-with-ai",
    "fill-w9-online",
    "auto-fill-pdf",
  ],
  "edit-pdf-free": [
    "add-text-to-pdf",
    "edit-pdf-with-ai",
    "fill-pdf-without-acrobat",
    "fill-pdf-online",
  ],
  "add-text-to-pdf": [
    "edit-pdf-free",
    "make-pdf-fillable",
    "fill-pdf-from-photo",
    "fill-pdf-online",
  ],
  "make-pdf-fillable": [
    "fill-pdf-from-photo",
    "add-text-to-pdf",
    "ai-pdf-filler",
    "edit-pdf-free",
  ],
  "fill-pdf-from-photo": [
    "make-pdf-fillable",
    "add-text-to-pdf",
    "fill-rental-application",
    "fill-pdf-online",
  ],
  "fill-pdf-without-acrobat": [
    "fill-pdf-online",
    "edit-pdf-free",
    "ai-pdf-filler",
    "add-text-to-pdf",
  ],
  "fill-rental-application": [
    "auto-fill-pdf",
    "fill-pdf-online",
    "ai-pdf-filler",
    "add-text-to-pdf",
  ],
  "fill-w9-online": [
    "fill-w4-online",
    "fill-1040-online",
    "ai-pdf-filler",
    "fill-pdf-online",
  ],
  "fill-w4-online": [
    "fill-w9-online",
    "fill-i9-online",
    "fill-1040-online",
    "fill-pdf-online",
  ],
  "fill-1040-online": [
    "fill-w4-online",
    "fill-w9-online",
    "ai-pdf-filler",
    "fill-pdf-online",
  ],
  "fill-i9-online": [
    "fill-w4-online",
    "fill-w9-online",
    "ai-pdf-filler",
    "fill-pdf-online",
  ],
};
